import React, { createContext, useState } from "react";
import { toast } from "react-toastify";
import LOCAL_KEYS, { parseLocalStorageJSON, setToLocalStorage } from "../../helpers/localstorage";
import Swal from "sweetalert2";
import { login as loginApi, forgotPassword as forgotPasswordApi} from "../../Services/authapis";

export const LoginContext = createContext();

export const LoginProvider = ({ children }) => {
  const [loginResponse, setLoginResponse] = useState(null);
  const [loginError, setLoginError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const getProfilePhoto = () => {
    const userDetails = parseLocalStorageJSON(LOCAL_KEYS.USER_DETAILS);

    const firstInitial = userDetails?.firstName?.charAt(0)?.toUpperCase() || "U";
    const lastInitial = userDetails?.lastName?.charAt(0)?.toUpperCase() || "";
    const nameSeed =
      (userDetails?.firstName || "") + (userDetails?.lastName || "") || "User";
    const colors = [
      "bg-[#201F1E]",
    ];
    const seedValue = nameSeed
      .split("")
      .reduce((acc, ch) => acc + ch.charCodeAt(0), 0);
    const bgColorClass = colors[seedValue % colors.length];

    return {
      initials: `${firstInitial}${lastInitial}`,
      bgColorClass,
      textColorClass: "text-white",
    };
  };


  const login = async (credentials) => {
    setIsLoading(true);
    try {
      // Simulate API call
      const response = await loginApi(credentials);
      setLoginResponse(response);

      // Allow ADMIN, MKTG_EXEC (marketing executive), and RECRUITER users
      if (response?.userDetails?.acctType !== "ADMIN" && response?.userDetails?.acctType !== "MKTG_EXEC" && response?.userDetails?.acctType !== "RECRUITER") {
        Swal.fire({
          title: "Error",
          text: "Invalid User",
          icon: "error",
          confirmButtonText: "Ok",
        });
        resetLoginState();
      } else if (response.access_token) {
        localStorage.setItem("access_token", response.access_token);
        setToLocalStorage(LOCAL_KEYS.USER_DETAILS, response.userDetails);

        if (response.message) {
          setToLocalStorage(LOCAL_KEYS.EXPIRY, true);
          toast.error("Your password is expired, please reset your password");
          resetLoginState();
        } else {
          toast.success("Login successful");
        }
      }
    } catch (error) {
      setLoginError(error);
      toast.error(error.message);
    } finally {
      setIsLoading(false);
    }
  };


  // Forgot Password function
  const forgotPassword = async (email) => {
    setIsLoading(true);
    try {
      // Call your API (should be a POST or GET as per your backend)
      const response = await forgotPasswordApi(email);
      toast.success("Password reset email sent!");
      return response;
    } catch (error) {
      toast.error(error.message || "Failed to send reset email");
      throw error;
    } finally {
      setIsLoading(false);
    }
  };

  const resetLoginState = () => {
    setLoginResponse(null);
    setLoginError(null);
  };

  return (
    <LoginContext.Provider
      value={{ loginResponse, loginError, isLoading, login, resetLoginState, forgotPassword, getProfilePhoto }}
    >
      {children}
    </LoginContext.Provider>
  );
};

// Simulated API call (replace with actual API logic)
